
































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import basicPage from "@/layouts/basicPage.vue";
import searchInput from "@/components/searchInput.vue";
import passwordModal from "@/views/usercenter/passwordModal.vue";
import util from "@/lib/util";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import _ from "lodash";
import Util from "@/lib/util";
import AppConsts from "@/lib/appconst";
import {paginationElement} from "@/api/typeDefined";


const APPLYSTATES = {"NOT": 1, "PROCEED": 2, "END": 3, "OK": 4};//报名培训状态 1：未开始，2：正在报名， 3：已结束 ，4 已报名


@Component({
  components: {}
})
export default class myApply extends basicPage {
  customActiveKey = '0'
  data: Array<Object> = [];

  handleTabClick(e) {
    this.customActiveKey = e;
  }

  pagination = {
    ...AppConsts.pagination,
    onChange: (current) => {
      this.pagination.current = current;
      this.loadData();
    }, onShowSizeChange: (current, pageSize) => {
      this.pagination.pageSize = pageSize;
      this.pagination.current = current;
      this.loadData();
    }
  };

  parameters = {
    keyWords: '',
    currentPage: this.pagination.current,
    pageSize: this.pagination.pageSize,
    status: null
  };


  loadData() {
    let self = this;
    this.parameters.currentPage = this.pagination.current;
    this.parameters.pageSize = this.pagination.pageSize;
    const queryParameters = {...this.parameters};
    ajaxHelperInstance.get('/web/meeting/search/getMyMeettingList', queryParameters, undefined, this).then((res) => {
      self.data = res.data.data.list || [];
      self.pagination.total = res.data.data.total;
    })
  }


  setKeywordsAndLoad(keywords) {
    this.parameters.keyWords = keywords;
    this.pagination.current = 1;
    this.loadData();
  }

  getThemeImgUrl(url) {
    if (url == '' || url == null) {
      url = "/img/training/trainBack.svg"
    } else {
      url = AppConsts.fileResourceUrl + url;
    }
    return url;
  }


  getPXImageUrl(item) {
    let ret = ''
    switch (item.pxstatus) {
      case 1: { //报名未开始
        ret = '/img/training/wks.png';
        break;
      }
      case 2: { //报名中
        ret = '/img/training/zzbm.png';
        break;
      }
      case 3: { //报名结束
        ret = '/img/training/yjs.png';
        break;
      }
      case 4: { //培训结束
        ret = '/img/training/pxjs.png';
        break;
      }
    }
    return ret;
  }

  viewTrain(item) {
    this.$router.push({
      name: 'trainDetail',
      params: {
        trainId: item.pxid
      }
    })
  }

  mounted() {
    this.loadData();
  }
}
